import React from 'react'
import { Sidebar } from '../../components/Sidebar/Sidebar'
import { Link } from 'react-router-dom'
import DataTable from 'react-data-table-component'
import Tippy from '@tippyjs/react'
import 'tippy.js/dist/tippy.css'
import axios from 'axios'
import { Baseurl } from '../../../Config/Baseurl'
import { useState } from 'react'
import { useEffect } from 'react'

export const ViewStudent = () => {
  const [data, setData] = useState([])
  const [filteredData, setFilteredData] = useState([])
  const [search, setSearch] = useState('')

  // get all registered students/candidate
  const getData = async () => {
    await axios
      .get(Baseurl.nodeLocal + 'auth/fetchAllStudents')
      .then((res) => {
        setData(res.data.data)
        setFilteredData(res.data.data)
      })
      .catch((err) => {})
  }

  useEffect(() => {
    getData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // to search candidates in table
  useEffect(() => {
    const result = data.filter((item) => {
      return (
        item.name.toLowerCase().match(search.toLowerCase()) ||
        item.institute.toLowerCase().match(search.toLowerCase()) ||
        item.course.toLowerCase().match(search.toLowerCase()) ||
        item.enrollment.match(search) ||
        item.applied_for.toLowerCase().match(search.toLowerCase()) ||
        item.ins_status.toLowerCase().match(search.toLowerCase())
      )
    })

    setFilteredData(result)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search])

  // columns to display student data in table
  const columns = [
    {
      name: 'Sr.no',
      selector: (row) => row.id,
      sortable: true,
      width: '80px',
    },
    {
      name: 'Name',
      selector: (row) => {
        return (
          <Tippy content={row.name} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
              className="text-truncate"
            >
              {row.name}
            </p>
          </Tippy>
        )
      },
      width: '130px',
    },
    {
      name: 'Email',
      selector: (row) => {
        return (
          <Tippy content={row.email} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
              className="text-truncate"
            >
              {row.email}
            </p>
          </Tippy>
        )
      },
    },
    {
      name: 'Contact',
      selector: (row) => {
        return (
          <Tippy content={row.contact} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
              className="text-truncate"
            >
              {row.contact}
            </p>
          </Tippy>
        )
      },
    },

    {
      name: 'College',
      selector: (row) => {
        return (
          <Tippy content={row.institute} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
              className="text-truncate"
            >
              {row.institute}
            </p>
          </Tippy>
        )
      },
    },

    {
      name: 'Applied For',
      selector: (row) => {
        return (
          <Tippy content={row.applied_for} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
              className="text-truncate"
            >
              {row.applied_for}
            </p>
          </Tippy>
        )
      },
      width: '130px',
    },

    {
      name: 'Recruitment',
      selector: (row) => row.ins_status,
    },
    {
      name: 'Actions',
      cell: (row) => {
        return (
          <div>
            <Link to={'/studentdetails/' + row.id} className="link">
              <button className="btn btn-outline-primary btn-sm">
                View Details
              </button>
            </Link>
          </div>
        )
      },
    },
  ]

  return (
    <div className="row">
      <div className="col-md-2">
        <Sidebar />
      </div>
      <div className="col-md-9 mt-4 p-2 mx-5">
        {/* breadcrumbs */}
        <div className="d-flex justify-contetn-center">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/examdashboard" className="link text-primary">
                  Home
                </Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Students List
              </li>
            </ol>
          </nav>
        </div>
        <div className="viewExamheader">
          <h4>Students List</h4>
          <Link to="/addstudent" className="link">
            <div className="addExamBtn">
              <button className="btn btn-primary ">Add Student</button>
            </div>
          </Link>
        </div>
        <div className="students mt-5">
          {/* dataTable */}
          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            highlightOnHover
            subHeader
            subHeaderComponent={
              <div className="mt-4 mb-4 w-100  d-flex justify-content-end">
                <div className="w-25">
                  {/* search bar to filter data in table */}
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search..."
                    name="search"
                    value={search}
                    onChange={(e) => {
                      setSearch(e.target.value)
                    }}
                  />
                </div>
              </div>
            }
          />
        </div>
      </div>
    </div>
  )
}
